import { TextField } from '@material-ui/core';
import React from 'react';
import ArticleField from '../ArticleField';

interface RevisionMessageProps {
    value: string,
    onChange: (value: string) => void
}

const RevisionMessage = (props: RevisionMessageProps) => {
    return <ArticleField>
        <TextField
            fullWidth={true}
            variant="outlined"
            multiline={true}
            rows={4}
            value={props.value}
            label="Message de révision"
            onChange={(e) => {
                props.onChange(e.target.value);
            }}
        />
    </ArticleField>
}

export default RevisionMessage;